// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileView_root__vp5a0","header":"MobileView_header__10PcU","columns":"MobileView_columns__2dACf","hide":"MobileView_hide__3W85j","show":"MobileView_show__uqTV-"};